module.exports = __webpack_public_path__ + "34736292/img/arrow-export-icon.a3345173.svg";